<template>
  <div id="sidebar" class="sidebar">
    <div class="logo">
      <router-link
        :to="{ name: 'Dashboard' }"
        active-class=""
      >
        <img :src="getImageUrl('/images/logo.png')" >
      </router-link>

    </div>
    <div>
      <div class="d-flex align-items-center">
        <p class="main-router-text">Main Menu</p>
        <div @click="closeSidebar" class="d-md-none d-sm-none" style="margin-left: 85px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
            <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/>
          </svg>
        </div>
      </div>
      <ul class="list-unstyled">
        <li>
          <div v-if="this.$route.name === 'Dashboard'" class="active-router"></div>
          <router-link :to="{name: 'Dashboard'}">
            <img v-if="this.$route.name === 'Dashboard'" :src="getImageUrl('/images/sidebar-icons/home-active.png')">
            <img v-else :src="getImageUrl('/images/sidebar-icons/home-disable.png')">
            <span>Dashboard</span>
          </router-link>
        </li>
        <li>
          <div v-if="this.$route.name === 'Regimen Builder'" class="active-router"></div>

          <span v-if="isRegimenCompleted">
            <router-link :to="{name: 'Regimen Calendar'}">
              <img v-if="this.$route.name === 'Regimen Calendar'" :src="getImageUrl('/images/sidebar-icons/regimen-active.png')">
              <img v-else :src="getImageUrl('/images/sidebar-icons/regimen-disable.png')">
              <span>Regimen</span>
            </router-link>
          </span>
          <span v-else>
            <router-link :to="{name: 'Regimen Builder'}">
              <img v-if="this.$route.name === 'Regimen Builder'" :src="getImageUrl('/images/sidebar-icons/regimen-active.png')">
              <img v-else :src="getImageUrl('/images/sidebar-icons/regimen-disable.png')">
              <span>Regimen</span>
            </router-link>
          </span>
        </li>
        <li>
          <div v-if="this.$route.name === 'Insights'" class="active-router"></div>
          <router-link :to="{name: 'Insights'}">
            <img v-if="this.$route.name === 'Insights'" :src="getImageUrl('/images/sidebar-icons/insight-active.png')">
            <img v-else :src="getImageUrl('/images/sidebar-icons/insight-disable.png')">
            <span>Insights</span>
          </router-link>
        </li>
        <li>
          <div v-if="this.$route.name === 'Curl Notes'" class="active-router"></div>
          <router-link :to="{name: 'Curl Notes'}">
            <img v-if="this.$route.name === 'Curl Notes'" :src="getImageUrl('/images/sidebar-icons/notes-active.png')">
            <img v-else :src="getImageUrl('/images/sidebar-icons/notes-disable.png')">
            <span>Notes</span>
          </router-link>
        </li>
        <li>
          <div v-if="this.$route.name === 'Shop'" class="active-router"></div>
          <router-link :to="{name: 'Shop'}">
            <img v-if="this.$route.name === 'Shop'" :src="getImageUrl('/images/sidebar-icons/product-active.png')">
            <img v-else :src="getImageUrl('/images/sidebar-icons/product-disable.png')">
            <span>Products</span>
          </router-link>
        </li>
      </ul>
      <hr class="hr">
      <p class="other">Other</p>
      <ul class="list-unstyled">
        <li>
          <div v-if="this.$route.name === 'home'" class="active-router"></div>
          <router-link :to="{name: 'home'}">
            <img v-if="this.$route.name === 'home'" :src="getImageUrl('/images/sidebar-icons/other-active.png')">
            <img v-else :src="getImageUrl('/images/sidebar-icons/other-disable.png')">
            <span>Help</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import profileMixin from "@/mixins/profileMixin";
import {mapGetters} from "vuex";

export default {
  mixins: [profileMixin],
  props: {
    role: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters(['user','userRegimenElements']),

    isRegimenCompleted() {
      return (this.userRegimenElements && this.userRegimenElements.length > 3) ? 'yes' : 'no';
    }

  },
  methods: {
    closeSidebar() {
      const elem = document.getElementById("sidebar");
      elem.classList.remove('active');


    }
  }
}
</script>



<style>
.main-router-text {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 15px;
  margin: 15px 0 20px 20px
}

.other {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 15px;
  margin: 26px 0 15px 20px
}

.active-router {

  width: 5px;
  height: 31px;
  background-color: #603975;
}

.active-router image {
  color: #6e3f80;
}

.hr {
  width: 126px;
  margin-top: 44px;
  height: 1.5px;
  margin-left: 30px;
}

.router-link-active {
  display: flex;
  align-items: center;
  height: 31px;
  width: 216px;
  background-color: #EFE4EF;
  padding-left: 20px !important;
}

.router-link-active span{
  color: #6e3f80;
  padding-left:5px!important;
}

#flush-headingFour :after {
  background-image: none;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-item:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.accordion-item {
  border: 0px solid;
}

.list-unstyled img{
  margin-right: 20px;
  color: #939EAB;
  width: 12px;
  height: 12px;
}

.list-unstyled li{
  display: flex;
  align-items: center;
  height: 31px;
}

.list-unstyled li:hover {
  background-color: #EFE4EF;
}

.list-unstyled a{
  border: none;
  color: #939EAB;
  padding-left: 25px;
}

.list-unstyled a:hover{
  color: #6e3f80;
}

.active{
  display: flex !important;
  z-index: 1005;
 
}

@media screen and (max-width: 550px) {
  .sidebar {
    display: none
  }
}

@media screen and (min-width: 1600px){
    .list-unstyled li {
      height: 51px;
    }
    .list-unstyled img{
      margin-right: 20px;
      color: #939EAB;
      width: 14px;
      height: 16px;
    }
    .list-unstyled span {
      font-size: 16px;
    }
    .active-router {
      height: 51px;
    }
    .router-link-active {
      height: 51px
    }
    .other {
      font-size: 14px
    }
    .main-router-text {
      font-size: 14px
    }
}
.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #E6A73F;
    border-color: #E6A73F;
}
.pagination li {
    display: inline;
    color: black;
    float: left;
    padding: 8px 12px;
    text-decoration: none;
    border-radius:5px;
}
.pagination{
  justify-content:center;
}
.page-link:hover {
    color: #000;
}
.page-link {
    color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue